import { useIdentityPermissions } from './useIdentityPermissions'
import { getAllowedMerchantCountries, getPermissionTarget, getSpecificMerchantIdsFromPermissionsV2 } from './permissionsV2'

export const useCurrentUserMerchantRoles = () => {
	const { permissions, loading, error } = useIdentityPermissions()
	const merchantTargets = [...new Set(permissions.map(getPermissionTarget).filter(target => target.startsWith('merchant:')))]
	const roles = merchantTargets.map(target => ({ target }))

	const allMerchants = !!roles.find(({ target }) => target === 'merchant:*')

	const hasCountryBasedAccess = getAllowedMerchantCountries(permissions).length > 0

	const merchantIdsFromV2 = getSpecificMerchantIdsFromPermissionsV2(permissions)
	const uniqueSpecificMerchantIds = [...new Set(merchantIdsFromV2)]

	const connectedToOnlyOneMerchant = !allMerchants && !hasCountryBasedAccess && uniqueSpecificMerchantIds.length === 1
	const connectedToMultipleMerchants = allMerchants || hasCountryBasedAccess || uniqueSpecificMerchantIds.length > 1

	const rolesExists = roles.length > 0 || uniqueSpecificMerchantIds.length > 0 || hasCountryBasedAccess

	const onlyOneConnectedMerchantId = () => uniqueSpecificMerchantIds[0]

	return {
		roles,
		allMerchants,
		connectedToOnlyOneMerchant,
		connectedToMultipleMerchants,
		onlyOneConnectedMerchantId,
		rolesExists,
		loading,
		error,
	}
}
